import { render, staticRenderFns } from "./blog-13.vue?vue&type=template&id=7022bd36&scoped=true"
import script from "./blog-13.vue?vue&type=script&lang=js"
export * from "./blog-13.vue?vue&type=script&lang=js"
import style0 from "./blog-13.vue?vue&type=style&index=0&id=7022bd36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7022bd36",
  null
  
)

export default component.exports